import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  OFFICE_DROPDOWN: `${cleanedFilename(__filename)}-office-dropdown`,
  USER_DROPDOWN: `${cleanedFilename(__filename)}-user-dropdown`,
  OVERWRITE_ASSIGNEE: `${cleanedFilename(__filename)}-overwrite-assignee`,
};
